import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type WishlistMetadataResponse } from '@app/client/resources/wishlists/types';

interface State {
    wishlistMetadata?: WishlistMetadataResponse;
    isFollowing?: boolean;
}
interface Actions {
    setWishlistMetadata: (wishlistMetadata: State['wishlistMetadata']) => void;
    setIsFollowing: (isFollowing: boolean) => void;
}
type WishlistPageStore = State & Actions;
const initialState: State = {
    wishlistMetadata: undefined,
    isFollowing: undefined,
};

export const STORE_KEY_WISHLIST_META = 'wishlist-metadata-store';
export const useWishlistMetadataStore = create<WishlistPageStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setIsFollowing: (isFollowing) => set({ isFollowing }),
            setWishlistMetadata: (wishlistMetadata) => set({ wishlistMetadata }),
        }),
        { name: STORE_KEY_WISHLIST_META },
    ),
);
